import { cx } from 'cvb';
import PropTypes from 'prop-types';
import { withApplicationContext } from '../../utils/ApplicationContext';
import { withLabels } from '../../utils/LabelsContext';
import { withProduct } from '../../utils/ProductContext';
import ProductPrices from '../ProductPrices/ProductPrices';
import ProductTopSpecifications from '../ProductTopSpecifications/ProductTopSpecifications';
import Heading from '../ui/Heading/Heading';
import LinkButton from '../ui/LinkButton/LinkButton';
import { useProductSpecificationConnect } from './hooks/useProductSpecificationConnect';
import { ProductSpecificationConnectStyles } from './ProductSpecificationConnect.style';

const ProductSpecificationConnect = ({ product, appCtx, labels }) => {
  const hookData = useProductSpecificationConnect({ product, appCtx });

  if (!hookData.shouldRender) {
    return null;
  }

  const {
    shouldRenderSpecifications,
    isMobile,
    isMobileOrTablet,
    displayPrice,
    isViewPlanActive,
    planUrl,
    productAttributes,
    productId,
    cmrPoints,
    regionCode,
  } = hookData;

  return (
    <div
      className="product-specifications"
      data-backend-category={productAttributes.merchantCategoryId}
      data-availability={productAttributes.isPrimeAvailable}
      data-published={productAttributes.isPublished}
      id="testId-ProductSpecificationConnect-container"
    >
      <div className="product-specifications-column">
        {shouldRenderSpecifications && <ProductTopSpecifications scollToElementId="productInfoContainer" />}
      </div>
      <div className={cx('product-specifications-column', isMobile && 'product-specifications-column-panel')}>
        {isViewPlanActive ? (
          <>
            {displayPrice && (
              <div className="connect-prices">
                <div className="info-message">{labels.TEAM_FROM_LABEL}</div>
                <ProductPrices
                  prices={displayPrice}
                  productId={productId}
                  regionCode={regionCode}
                  cmrPoints={cmrPoints}
                  isMobile={isMobile}
                />
              </div>
            )}
            <div className="plan-review-container">
              <div className="info-message">{labels.IDEAL_PLAN_LABEL}</div>
              <p className="plan-review-text">{labels.PLAN_REVIEW_LABEL}</p>
            </div>
            <div className={isMobileOrTablet ? 'viewPlans-container' : ''}>
              <LinkButton
                href={planUrl}
                type="rebranding"
                size={!isMobileOrTablet ? 'large' : 'medium'}
                id="testId-ProductSpecificationConnect-viewPlan"
              >
                <span>{labels.VIEW_PLANES_LABEL_REBRANDING}</span>
              </LinkButton>
            </div>
          </>
        ) : (
          <>
            <Heading labels={3} variation="title8">
              {labels.NO_PLAN_TITLE}
            </Heading>
            <p className="no-plan-text">{labels.NO_PLAN_LABEL}</p>
          </>
        )}
      </div>
      <style jsx>{ProductSpecificationConnectStyles}</style>
    </div>
  );
};

ProductSpecificationConnect.propTypes = {
  product: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
};

export { ProductSpecificationConnect };
export default withProduct(withApplicationContext(withLabels(ProductSpecificationConnect)));
